import {creates, hoistCmp} from '@xh/hoist/core';
import {configurableGrid} from '../../../../cmp/gridSpec/ConfigurableGrid';
import {PositionsWidgetModel} from './PositionsWidgetModel';

export const positionsWidget = hoistCmp.factory<PositionsWidgetModel>({
    model: creates(() => PositionsWidgetModel),
    render({model}) {
        return configurableGrid({model: model.configurableGridModel});
    }
});
